import api from "./api";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function normalizeDeletionImpact(data = {}) {
  const counts = data.counts ?? data.Counts ?? {};
  return {
    teacherId: data.teacherId ?? data.TeacherId,
    regNumber: data.regNumber ?? data.RegNumber ?? "",
    name: data.name ?? data.Name ?? "",
    preName: data.preName ?? data.PreName ?? "",
    phone: data.phone ?? data.Phone ?? "",
    status: data.status ?? data.Status ?? "",
    requiredConfirmation:
      data.requiredConfirmation ?? data.RequiredConfirmation ?? "",
    canDelete: Boolean(data.canDelete ?? data.CanDelete),
    blockingReasons:
      data.blockingReasons ?? data.BlockingReasons ?? [],
    counts,
  };
}

export function deletionErrorDetails(error, fallback = "Unable to delete this teacher.") {
  const data = error?.response?.data ?? {};
  const validation = data.errors ?? data.Errors ?? {};
  const fieldErrors = Object.entries(validation).flatMap(([field, messages]) =>
    (Array.isArray(messages) ? messages : [messages])
      .filter(Boolean)
      .map((message) => `${field}: ${message}`)
  );
  return {
    code: data.code ?? data.Code ?? "",
    message: data.message ?? data.Message ?? error?.message ?? fallback,
    fieldErrors,
  };
}

export async function fetchTeacherDeletionImpact(teacherId, { signal } = {}) {
  const { data } = await api.get(`/Teacher/${teacherId}/deletion-impact`, {
    headers: authHeaders(),
    signal,
  });
  return normalizeDeletionImpact(data);
}

export async function deleteTeacherPermanently(teacherId, { reason, confirmation }) {
  const { data } = await api.delete(`/Teacher/${teacherId}`, {
    headers: authHeaders(),
    data: { reason: String(reason).trim(), confirmation },
  });
  return data;
}
